<template>
    <div class="header">
        <div class="min_header">
            <div class="logo" @click="refresh">
                <span>托乐乐</span><span>云端助教</span>
            </div>
            <span>
                <router-link to='/home/index'>首页</router-link>
            </span>
            <span>
                <router-link to='/home/aboutus'>关于云端助教</router-link>
            </span>
            <span>
                <a href="https://assistant.tuolele.cn/index.html" target="view_windo" el="nofollow" class="hover">加入我们</a>
                  <!-- target="view_window"  跳转外链打开新窗口 -->
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    methods: {
        refresh() {
            window.location.href = '/';
            // location.reload(); // 刷新本页
            // this.$router.push({path: '/'}); // 路由切换至首页
            // this.$router.replace({path: '/'}); // 路由切换至首页
        }
    }
}
</script>

<style scoped lang='scss'>
.min_header>span:nth-child(2) {
    margin-left: 660px;
    font-size: 15px;
}

.router-link-active {
    color:#2e92f0;
}

a:hover {
    color: #31b3fd!important;

}

.hover:hover {
    color: #31b3fd!important;
    border: solid 1px #31b3fd!important;
}

.header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    .min_header {
        max-width: 1200px;
        min-width: 1100px;
        height: 100%;
        margin: 0 auto;
        .logo {
            float: left;
            font-size: 25px;
            cursor: pointer;
            font-weight:bold;
            span {
                &:first-child {
                    color: #2995e9;
                }
                &:last-child {
                    color: #3c3c3c;
                }
            }
        }
        span {
        //     &:nth-child(2) {
        //         margin-left: 473px;
        //         font-size: 15px;
        //     }
            &:nth-child(3) {
                margin-left: 47px;
                font-size: 15px;
            }
            &:nth-child(4) {
                width: 64px;
                height: 28px;
                margin-left: 90px;
                a {
                    font-size: 14px;
                    color: #2e92f0;
                    padding: 3px 10px;
                    border: solid 1px #d4e8fd;
                    border-radius: 3px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue